import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { OAuthService } from 'angular-oauth2-oidc';
import { Store } from '@ngrx/store';
import * as authActions from 'app/auth/store/auth.actions';
import { environment } from 'environments/environment';

const AZURE_TOKEN_URL = `${environment.apiUrl}/oauth/azure/token`;

@Injectable()
export class OAuthInterceptor implements HttpInterceptor {
    constructor(
        private oauthService: OAuthService,
        private store: Store
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.startsWith('http') || req.url.indexOf(AZURE_TOKEN_URL) === -1) {
            return next.handle(req);
        }

        const accessToken = this.oauthService.getAccessToken();
        const authReq = accessToken
            ? req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
            : req;

        return next.handle(authReq).pipe(
            tap(
                event => {}, // tslint:disable-line
                err => {
                    if (err instanceof HttpErrorResponse && err.status === 401) {
                        this.store.dispatch(authActions.loginFail({
                            errorMessage: 'Your account is not authorized. Try with a standard account or logout.'
                        }));
                    }
                }
            )
        );
    }
}
